import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/book/$bookId/stats")({
  component: lazyRouteComponent(
    () => import("../pages/Book/components/BookStatisticsPage"),
    "BookStatisticsPage",
  ),
});
